export default __webpack_public_path__ + "static/media/bingoHouse.88b2601a.png";